import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { SrRefundInputCrewGet, SrRefundRow, SrRefundService } from '@app/services/sr-refund.service';

@Component({ selector: 'tt-sr-refund-input-crew', templateUrl: './sr-refund-input-crew.component.html', styleUrls: ['./sr-refund-input-crew.component.css'], standalone: false })
export class SrRefundInputCrewComponent implements OnInit {
    public page?: SrRefundInputCrewGet;
    public inputs: SrRefundRow[] = [];
    public saving = false;
    public deleting = false;
    public calculating = false;
    public error = '';
    public get hasPassengers(): boolean { return Number(this.page?.private_car_nbr_of_passengers) > 0; }
    constructor(private readonly refund: SrRefundService, private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) { this.navigator = useNavigatorFor(navigator, this); }
    public async ngOnInit(): Promise<void> {
        try {
            this.page = await this.refund.getCrewInput({ checklistdata_keyno: String(this.navigator?.params['checklistdata_keyno'] ?? ''), srrefundinput_keyno: String(this.navigator?.params['srrefundinput_keyno'] ?? '') });
            if (this.page.srrefundinput_keyno?.trim()) { this.inputs = []; this.inputs = await this.refund.getInputs({ srrefundinput_keyno: this.page.srrefundinput_keyno }); }
        } catch (error) { this.showError(error); }
    }
    public async onTimeChanged(field: 'signin_dt' | 'signout_dt' | 'has_signed_out', value: string): Promise<void> {
        if (!this.page) return;
        const previous = this.page[field]; this.page[field] = value;
        if (previous === undefined || value === undefined || previous === value || previous.length > 16 || value.length > 16) return;
        if (!this.page.signin_dt?.trim() || !this.page.has_signed_out?.trim() || !this.page.signout_dt?.trim()) return;
        try { this.page.hours_total = (await this.refund.calculateCrewHours(this.page)).hours_total; } catch (error) { this.showError(error); }
    }
    public async calculate(field: 'private_car_nbr_of_passengers' | 'private_car_km' | 'private_car_km_trailer' | 'private_car_km_forest_road' | 'private_car_km_passenger' | 'roadtoll_amount' | 'diver_hours_diving' | 'diver_hours_lineman' | 'smallboat_helpman_hours'): Promise<void> {
        if (!this.page || this.calculating) return;
        this.calculating = true;
        try { const value: unknown = await this.modal.showCalculator(field, undefined, this.page[field]); if (typeof value === 'string' || typeof value === 'number') this.page[field] = value; }
        catch (error) { this.showError(error); } finally { this.calculating = false; }
    }
    public async save(): Promise<void> {
        if (!this.page || this.saving) return;
        this.saving = true;
        try { const response = await this.refund.saveCrewInput(this.page); if (response.errorcode !== '0') await this.showWarning(response.errormessage); else this.navigator?.back(); }
        catch (error) { this.showError(error); } finally { this.saving = false; }
    }
    public async delete(): Promise<void> {
        if (!this.page || this.deleting) return;
        this.deleting = true;
        // Legacy deletion retains its delete lock and releases the save lock after a response.
        try { const response = await this.refund.deleteCrewInput(this.page); if (response.errorcode !== '0') await this.showWarning(response.errormessage); else this.navigator?.back(); this.saving = false; }
        catch (error) { this.showError(error); }
    }
    private showWarning(message: string): Promise<void> { return this.modal.show({ type: 'warning', title: 'Varsel', message, buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] }); }
    private showError(error: unknown): void { this.error = error instanceof Error ? error.message : String(error); }
}
